(function () {
    'use strict';

    angular
        .module('app')
        .controller('RoleEditController', lController);

    function lController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state, $stateParams, RoleService, toaster) {
        var model = this;

        $scope.roleId = $stateParams.roleId;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToRoleEdit = function (roleId) {
            $state.go('roleEdit', { 'roleId': roleId });

        }
    }
})();
